import React, { useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const AddHandpickedBondModal = ({ isOpen, onClose, onSubmit, editData }) => {
  // States
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedBonds, setSelectedBonds] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const { cmsData, cmsBondListData } = useSelector((state) => state.cmsData);

  // Reset states when modal opens
  useEffect(() => {
    if (isOpen) {
      if (editData) {
        // If editing, initialize with the edit data
        setSelectedBonds([editData]);
      } else {
        // If adding new, reset the form
        setSelectedBonds([]);
      }
      setSearchQuery("");
      setSearchResults([]);
    }
  }, [isOpen, editData]);

  // Mock search function - replace with actual API call
  const handleSearch = (query) => {
    // Simulate API search results
    const mockResults = cmsBondListData?.filter((bond) =>
      bond.name.toLowerCase().includes(query.toLowerCase())
    );
    setSearchResults(query ? mockResults : []);
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    handleSearch(query);
  };

  // Handle bond selection
  const handleBondSelect = (bond) => { if (!selectedBonds.find((b) => b.id === bond.id)) {
    setSelectedBonds([...selectedBonds, bond]);
  }
    setSearchQuery("");
    setSearchResults([]);
  };

  // Handle bond removal
  const handleBondRemove = (bondId) => {
    setSelectedBonds(selectedBonds.filter((bond) => bond.id !== bondId));
  };

  // Handle form submission
  const handleSubmit = () => {
    onSubmit?.(selectedBonds);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div
          className="relative w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 shadow-xl transition-all"
          onClick={(e) => e.stopPropagation()}
        >
          <h2 className="text-xl font-medium mb-6">Add Handpicked Bond</h2>

          {/* Search Section */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">
              Search Bond
            </label>
            <div className="relative">
              <input
                type="text"
                value={searchQuery}
                onChange={handleSearchChange}
                placeholder="Prachay"
                className="w-full p-2 pr-10 border rounded-md"
              />
              <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                {/* <Search className="h-5 w-5 text-gray-400" /> */}
              </div>
            </div>

            {/* Search Results Dropdown */}
            {searchResults.length > 0 && (
              <div className="absolute z-10 mt-1 w-full bg-white border rounded-md shadow-lg">
                {searchResults.map((bond) => (
                  <div
                    key={bond.id}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => handleBondSelect(bond)}
                  >
                    {bond.name}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Selected Bonds */}
          <div className="min-h-[100px] mb-4 p-4 border rounded-md">
            <div className="flex flex-wrap gap-2">
              {selectedBonds.map((bond) => (
                <div
                  key={bond.id}
                  className="flex items-center gap-1 px-3 py-1 bg-blue-100 rounded-full"
                >
                  <span>{bond.name}</span>
                  <button
                    onClick={() => handleBondRemove(bond.id)}
                    className="ml-1 text-gray-500 hover:text-gray-700"
                  >
                    {/* <X className="h-4 w-4" /> */}
                    <IoIosClose />
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-4 mt-6">
            <button
              onClick={onClose}
              className="flex-1 py-2 px-4 border rounded-md text-blue-600 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="flex-1 py-2 px-4 rounded-md bg-blue-600 text-white hover:bg-blue-700"
              disabled={selectedBonds.length === 0}
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddHandpickedBondModal;
